import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SubscriptionCompletePage.css'; // We'll create this CSS file next for styling

const SubscriptionCompletePage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the buddy page after 3 seconds
    const timer = setTimeout(() => {
      navigate('/buddy');
    }, 3000); // 3000 milliseconds = 3 seconds

    // Cleanup the timer if the component unmounts before the timeout finishes
    return () => clearTimeout(timer);
  }, [navigate]); // Dependency array ensures this effect runs only once

  return (
    <div className="subscription-complete-container">
      <img 
          src="/images/PokerBuddy.png" 
          alt="PokerBuddy" 
          style={{height: '50px', marginBottom: '20px'}} 
      />
      <h1>Thank You for Subscribing!</h1>
      <p>Your premium access is now active.</p>
      <p>You will be redirected to the Buddy page shortly...</p>
      {/* Optional: Add a loading spinner or animation here */}
    </div>
  );
};

export default SubscriptionCompletePage; 